/**
 * Agent类型配置
 * 可以根据部署环境在环境变量中配置启用的agent类型
 */

export interface AgentTypeConfig {
  id: string;
  name: string;
}

/**
 * 所有可用的 Agent 类型
 */
export const AVAILABLE_AGENT_TYPES: AgentTypeConfig[] = [
  {
    id: 'general_agent',
    name: 'General Agent',
  },
  //隐藏旧agent创建途径
  // {
  //   id: 'agent',
  //   name: 'Agent',
  // },
];

/**
 * 获取启用的 Agent 类型
 * 从环境变量 VITE_ENABLED_AGENT_TYPES 读取配置
 * 格式: "agent,catalog_agent" 或 空字符串表示启用所有
 */
export const getEnabledAgentTypes = (): AgentTypeConfig[] => {
  const enabledTypes =
    (window as any).ENV?.GBASE_SUPPORT_FRONTEND_VITE_ENABLED_AGENT_TYPES || import.meta.env.VITE_ENABLED_AGENT_TYPES;

  // 如果没有配置或为空，返回所有类型
  if (!enabledTypes || enabledTypes === '') {
    return AVAILABLE_AGENT_TYPES;
  }

  // 解析配置的类型ID
  const enabledIds = enabledTypes.split(',').map((id: string) => id.trim());

  // 过滤出启用的类型
  return AVAILABLE_AGENT_TYPES.filter((type) => enabledIds.includes(type.id));
};
